// DateSlider.js
import React, { useState, useRef, useEffect } from 'react';
import { Flex, Box, Text, Button, Popover, PopoverTrigger, PopoverContent, PopoverHeader, PopoverBody, useDisclosure } from '@chakra-ui/react';
import Calendar from 'react-calendar';
import { IoChevronBackOutline, IoChevronForwardOutline } from 'react-icons/io5';
import 'react-calendar/dist/Calendar.css'
import { format } from 'date-fns';
import { th } from 'date-fns/locale/th';
import moment from 'moment';

const DatePickerWidget = ({setSelectedDay}) => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const {isOpen, onOpen, onClose} = useDisclosure()

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setSelectedDay(moment(date).format("YYYY-MM-DD"))
    onClose();
  };

  return (
    <Box>
      <Flex align="center" justify="center" mb="1">
        <Button onClick={() => handleDateChange(new Date(selectedDate.getTime() - 86400000))}>
          <IoChevronBackOutline />
        </Button>
        <Popover isLazy placement="top" onOpen={onOpen}
        onClose={onClose} isOpen={isOpen}>
          <PopoverTrigger>
            <Button onClick={()=>{onOpen()}} mx="2">
            <Text fontSize={14}>{format(selectedDate, 'EEE dd MMM yyyy', { locale: th })}</Text>
            </Button>
          </PopoverTrigger>
          <PopoverContent>
            <PopoverHeader align="center">เลือกวัน</PopoverHeader>
            <PopoverBody>
              <Calendar
                onChange={handleDateChange}
                value={selectedDate}
              />
              <Flex justify={"center"} width="100%">
              <Button variant={"ghost"} size={"sm"} my={2} onClick={()=>{onClose()}}>ยกเลิก</Button>
              </Flex>
            </PopoverBody>
            
          </PopoverContent>
        </Popover>
        <Button onClick={() => handleDateChange(new Date(selectedDate.getTime() + 86400000))}>
          <IoChevronForwardOutline />
        </Button>
      </Flex>
    </Box>
  );
};

export default DatePickerWidget;
